// ============================================
// NAVBAR COMPONENT - Shrileela Beach Resort
// ============================================

import { useState, useEffect } from 'react';
import { logoimages } from '../../data/logoimages';

const Navbar = ({ onBookNow }) => { 
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 30);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - 75, behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const handleBookNow = () => {
    setIsMobileMenuOpen(false);
    if (onBookNow) onBookNow();
  };

  const navLinks = [
    { name: 'Home', id: 'home' },
    { name: 'Rooms', id: 'rooms' },
    { name: 'Dining', id: 'dining' },
    { name: 'Gallery', id: 'gallery' },
    { name: 'Events', id: 'events' },
    { name: 'Contact', id: 'contact' }
  ];

  return (
    <>
   <style>{`
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&family=Jost:wght@300;400;500;600&display=swap');
  
  .nav-root {
    font-family: 'Jost', sans-serif;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
    transition: all 0.4s ease;
  }
  .nav-root.scrolled {
    background: rgba(255,255,255,0.97);
    backdrop-filter: blur(12px);
    box-shadow: 0 2px 30px rgba(0,0,0,0.08);
    padding: 0;
  }
  .nav-root.top {
    background: transparent;
    padding: 0;
  }
  .nav-inner {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 72px;
  }
  .nav-logo {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
  }
  .nav-logo-img {
    width: 66px;
    height: 66px;
    object-fit: contain;
    transition: transform 0.3s, filter 0.4s;
  }
  .nav-logo:hover .nav-logo-img { transform: scale(1.08); }
  .top .nav-logo-img { filter: brightness(0) invert(1); }
  .scrolled .nav-logo-img { filter: none; }
  .nav-logo-text {
    font-family: 'Playfair Display', serif;
    font-size: 18px;
    font-weight: 700;
    line-height: 1.1;
    transition: color 0.3s;
  }
  .nav-logo-sub {
    font-family: 'Jost', sans-serif;
    font-size: 10px;
    letter-spacing: 2.5px;
    font-weight: 500;
    text-transform: uppercase;
    transition: color 0.3s;
  }
  .scrolled .nav-logo-text { color: #3d5a3e; }
  .scrolled .nav-logo-sub { color: #888; }
  .top .nav-logo-text { color: #fff; }
  .top .nav-logo-sub { color: rgba(255,255,255,0.7); }
  
  .nav-links {
    display: flex;
    align-items: center;
    gap: 6px;
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .nav-link-btn {
    background: none;
    border: none;
    cursor: pointer;
    font-family: 'Jost', sans-serif;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.5px;
    padding: 8px 14px;
    border-radius: 6px;
    transition: all 0.25s;
  }
  .scrolled .nav-link-btn { color: #444; }
  .scrolled .nav-link-btn:hover { color: #3d5a3e; background: #f0f5f0; }
  .top .nav-link-btn { color: rgba(255,255,255,0.9); }
  .top .nav-link-btn:hover { color: #fff; background: rgba(255,255,255,0.12); }
  
  .nav-book-btn {
    background: #3d5a3e;
    color: #fff !important;
    border: none;
    cursor: pointer;
    font-family: 'Jost', sans-serif;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 1px;
    text-transform: uppercase;
    padding: 10px 22px;
    border-radius: 40px;
    transition: all 0.25s;
    margin-left: 8px;
  }
  .nav-book-btn:hover { background: #2d4230; transform: translateY(-1px); box-shadow: 0 6px 20px rgba(61,90,62,0.35); }
  .top .nav-book-btn { background: rgba(255,255,255,0.2); border: 1.5px solid rgba(255,255,255,0.5); }
  .top .nav-book-btn:hover { background: #fff; color: #3d5a3e !important; }
  
  .nav-mobile-toggle {
    display: none;
    background: none;
    border: none;
    cursor: pointer;
    padding: 8px;
    flex-direction: column;
    gap: 5px;
  }
  .hamburger-line {
    width: 24px;
    height: 2px;
    border-radius: 2px;
    transition: all 0.3s;
  }
  .scrolled .hamburger-line { background: #3d5a3e; }
  .top .hamburger-line { background: #fff; }
  
  .mobile-menu {
    display: none;
    position: absolute;
    top: 72px;
    left: 0;
    right: 0;
    background: rgba(255,255,255,0.98);
    backdrop-filter: blur(20px);
    padding: 16px 24px 24px;
    box-shadow: 0 20px 40px rgba(0,0,0,0.12);
    animation: slideDown 0.2s ease;
  }
  .mobile-menu.open { display: block; }
  @keyframes slideDown { from { opacity: 0; transform: translateY(-10px); } to { opacity: 1; transform: translateY(0); } }
  
  .mobile-link {
    display: block;
    width: 100%;
    background: none;
    border: none;
    text-align: left;
    font-family: 'Jost', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #333;
    padding: 14px 0;
    border-bottom: 1px solid #f0f0f0;
    cursor: pointer;
    transition: color 0.2s;
  }
  .mobile-link:hover { color: #3d5a3e; }
  .mobile-book-btn {
    width: 100%;
    background: #3d5a3e;
    color: #fff;
    border: none;
    font-family: 'Jost', sans-serif;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 1px;
    text-transform: uppercase;
    padding: 14px;
    border-radius: 40px;
    margin-top: 16px;
    cursor: pointer;
    transition: background 0.2s;
  }
  .mobile-book-btn:hover { background: #2d4230; }

  /* ===== MOBILE FIXES ===== */
  @media (max-width: 768px) {
    .nav-links { display: none; }
    .nav-book-btn { display: none; }
    .nav-mobile-toggle { display: flex; }

    /* Always show white nav background on mobile */
    .nav-root.top {
      background: rgba(255,255,255,0.97);
      backdrop-filter: blur(12px);
      box-shadow: 0 2px 30px rgba(0,0,0,0.08);
    }

    /* Fix logo image — no invert on mobile */
    .top .nav-logo-img { filter: none; }

    /* Fix logo text color on mobile */
    .top .nav-logo-text { color: #3d5a3e; }
    .top .nav-logo-sub { color: #888; }

    /* Fix hamburger color on mobile */
    .top .hamburger-line { background: #3d5a3e; }
  }
`}</style>

      <nav className={`nav-root ${isScrolled ? 'scrolled' : 'top'}`}>
        <div className="nav-inner">
          <div className="nav-logo" onClick={() => scrollTo('home')}>
            <img  src={logoimages.logos.shrileela} 
  alt="Shrileela Beach Resort Logo" 
  className="nav-logo-img"  />
            <div>
              <div className="nav-logo-text">Shrileela</div>
              <div className="nav-logo-sub">Beach Resort</div>
            </div>
          </div>

          <ul className="nav-links">
            {navLinks.map(link => (
              <li key={link.id}>
                <button className="nav-link-btn" onClick={() => scrollTo(link.id)}>{link.name}</button>
              </li>
            ))}
            <li>
              {/* ✅ Calls onBookNow to open modal */}
              <button className="nav-book-btn" onClick={handleBookNow}>Book Now</button>
            </li>
          </ul>

          <button className="nav-mobile-toggle" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
            <span className="hamburger-line" style={{ transform: isMobileMenuOpen ? 'rotate(45deg) translate(5px, 5px)' : 'none' }} />
            <span className="hamburger-line" style={{ opacity: isMobileMenuOpen ? 0 : 1 }} />
            <span className="hamburger-line" style={{ transform: isMobileMenuOpen ? 'rotate(-45deg) translate(5px, -5px)' : 'none' }} />
          </button>
        </div>

        <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
          {navLinks.map(link => (
            <button key={link.id} className="mobile-link" onClick={() => scrollTo(link.id)}>{link.name}</button>
          ))}
          {/* ✅ Also works in mobile menu */}
          <button className="mobile-book-btn" onClick={handleBookNow}>Book Your Stay</button>
        </div>
      </nav>
    </>
  );
};

export default Navbar;